var map = {
	"./main/dashboard/project/project.module": [
		"./src/app/main/dashboard/project/project.module.ts",
		"default~main-dashboard-project-project-module~main-settings-settings-module",
		"main-dashboard-project-project-module"
	],
	"./main/manage-business/manage-business.module": [
		"./src/app/main/manage-business/manage-business.module.ts",
		"default~main-manage-business-manage-business-module~main-manage-charity-manage-charity-module~main-m~affe566d",
		"default~main-manage-business-manage-business-module~main-premium-tags-premium-tags-module~main-user-~093fd6c0",
		"default~main-manage-business-manage-business-module~main-premium-tags-premium-tags-module",
		"common",
		"main-manage-business-manage-business-module"
	],
	"./main/manage-charity/manage-charity.module": [
		"./src/app/main/manage-charity/manage-charity.module.ts",
		"default~main-manage-business-manage-business-module~main-manage-charity-manage-charity-module~main-m~affe566d",
		"main-manage-charity-manage-charity-module"
	],
	"./main/manage-pet/manage-pet.module": [
		"./src/app/main/manage-pet/manage-pet.module.ts",
		"default~main-manage-business-manage-business-module~main-manage-charity-manage-charity-module~main-m~affe566d",
		"main-manage-pet-manage-pet-module"
	],
	"./main/manage-tags/manage-tags.module": [
		"./src/app/main/manage-tags/manage-tags.module.ts",
		"default~main-manage-business-manage-business-module~main-manage-charity-manage-charity-module~main-m~affe566d",
		"common",
		"main-manage-tags-manage-tags-module"
	],
	"./main/pages/pages.module": [
		"./src/app/main/pages/pages.module.ts",
		"main-pages-pages-module"
	],
	"./main/premium-tags/premium-tags.module": [
		"./src/app/main/premium-tags/premium-tags.module.ts",
		"default~main-manage-business-manage-business-module~main-manage-charity-manage-charity-module~main-m~affe566d",
		"default~main-manage-business-manage-business-module~main-premium-tags-premium-tags-module~main-user-~093fd6c0",
		"default~main-manage-business-manage-business-module~main-premium-tags-premium-tags-module",
		"main-premium-tags-premium-tags-module"
	],
	"./main/settings/settings.module": [
		"./src/app/main/settings/settings.module.ts",
		"default~main-manage-business-manage-business-module~main-manage-charity-manage-charity-module~main-m~affe566d",
		"default~main-dashboard-project-project-module~main-settings-settings-module",
		"main-settings-settings-module"
	],
	"./main/user-manage/user-manage.module": [
		"./src/app/main/user-manage/user-manage.module.ts",
		"default~main-manage-business-manage-business-module~main-manage-charity-manage-charity-module~main-m~affe566d",
		"default~main-manage-business-manage-business-module~main-premium-tags-premium-tags-module~main-user-~093fd6c0",
		"main-user-manage-user-manage-module"
	],
	"./main/user-pages/user-pages.module": [
		"./src/app/main/user-pages/user-pages.module.ts",
		"main-user-pages-user-pages-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;